import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-mist" data-id="element-27" data-mp="gxq6fntr12oh">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-28" data-mp="vtxn4e5y7lz0">
        <SectionHeader id="bonos" title="5 Bonos incluidos" description="Y además recibes 5 recursos prácticos — GRATIS con tu compra." data-id="element-29" data-mp="qtt7srgs0xad" />
        <ul className="mt-2.5 grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-30" data-mp="14rhrvx30s0ed">
          {bonuses.map((b, i) => <li key={b.title} className={`flex flex-col rounded-lg border-2 border-dashed border-tech/40 bg-white p-2.5 ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-31" data-mp="zsnamzkpajwd" data-mpi={i}>
              <p className="self-start rounded bg-navy px-1.5 pt-0.5 font-bebas text-sm leading-tight tracking-wide text-volt" data-id="element-32" data-mp="1njahrimsl5hv">
                Bono {i + 1} — Gratis
              </p>
              <h3 className="mt-1 font-condensed text-sm font-bold text-navy sm:text-base" data-id="element-33" data-mp="3pqttoki7txeu">{b.title}</h3>
              <p className="mt-0.5 text-[0.78rem] leading-snug text-navy/75 sm:text-sm" data-id="element-34" data-mp="3tr5dxw6o1vps">{b.desc}</p>
              <p className="mt-auto pt-1 text-xs font-semibold text-navy/70" data-id="element-35" data-mp="2lcoc3ww3fqy">
                Valor:{' '}
                <span className="font-bebas text-base font-normal tracking-wide text-navy line-through decoration-alert decoration-2" data-id="element-36" data-mp="7kyz86p8wjwl">
                  {b.value}
                </span>
              </p>
            </li>)}
        </ul>
        <div className="mt-2 rounded-lg border-2 border-volt bg-navy p-2.5 text-center" data-id="element-37" data-mp="gjapg7m79foi">
          <p className="font-display text-sm font-extrabold text-white sm:text-base" data-id="element-38" data-mp="lcvp043fyhpt">
            💰 Valor total de los 5 bonos:{' '}
            <span className="font-bebas text-xl font-normal tracking-wide line-through decoration-alert decoration-2" data-id="element-39" data-mp="vajm30ois1b5">
              {BONUS_TOTAL}
            </span>
          </p>
          <p className="font-display text-sm font-extrabold text-volt" data-id="element-40" data-mp="10709fsnwabn6">🔥 Hoy los 5 están incluidos gratis.</p>
        </div>
      </div>
    </section>;
}